import React from 'react';

import styled from 'styled-components';

export const Icon = styled.img`
  height: 10px;
  margin-left: 8px;
`;

interface TagStyledProps extends React.HTMLProps<HTMLSpanElement> {
  styledProps: {
    brightColor: boolean;
    isOpen: boolean;
    noIcon?: boolean;
  };
}

export const Tag = styled.span<TagStyledProps>`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 10px;
  border-radius: 16px;
  padding: 2px 11px 2px 14px;
  margin-bottom: 2.5px;
  width: fit-content;
  z-index: ${({ styledProps }) => (styledProps.isOpen ? 101 : 'intial')};
  color: ${({ theme, styledProps }) => (styledProps.brightColor ? theme.breakTag.brightColor : theme.breakTag.color)};
  background-color: ${({ theme, styledProps }) =>
    styledProps.brightColor ? theme.breakTag.brightBackground : theme.breakTag.background};

  &:last-child {
    margin-top: 0;
  }

  ${({ styledProps }) => {
    if (!styledProps.noIcon) {
      return `
      &::after {
        content: "";
        height: 12px;
        width: 12px;
        margin-left: 7px;
        display: block;
        background-size: cover;
        background-position: center;
        flex-grow: 0;
        flex-shrink: 0;
        background-image: url(${
          styledProps.brightColor ? '/corporate/images/exceeded-icon-white.svg' : '/corporate/images/exceeded-icon.svg'
        });
      }`;
    }
  }}
`;
